module.exports = __webpack_public_path__ + "img/Zoom_Cahora_20200127_S2_hell.04b91999.jpg";